import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class SettingService {
  async searchLocation(typeSearch, keyword) {
    try {
      const response = await HttpClient.get(
        `/api/setting/location/search?typeSearch=${typeSearch}&keyword=${keyword || `""`
        }`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getBranchList(body) {
    try {

      console.log(body);
      // const params = qs.stringify({
      //   ...(body && body.isThailand && { isThailand: body.isThailand }),
      //   ...(body && body.allStatus && { allStatus: body.allStatus }),
      // });
      const params = qs.stringify({
        ...(body && body.isThailand && { isThailand: body.isThailand }),
        ...(body && body.allStatus && { allStatus: body.allStatus })
      });


      console.log(params);

      const response = await HttpClient.get(
        `/api/setting/branch/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new SettingService();
